import { DatePipe, DecimalPipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { DialogInformationComponent } from 'src/app/shared/components/dialog-information/dialog-information.component';
import { Equipo } from 'src/app/shared/models/equipo';
import { ManoDeObra } from 'src/app/shared/models/mano-de-obra';
import { Partida } from 'src/app/shared/models/partida';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-detalle-partida',
  templateUrl: './detalle-partida.component.html',
  styleUrls: ['./detalle-partida.component.css'],
  providers: [DatePipe, DecimalPipe]
})
export class DetallePartidaComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  departureDetailForm: FormGroup;
  displayedColumnsMaterial: string[] = ['position', 'reference', 'descripcion', 'unidad', 'cantidad', 'desperdicio', 'precio', 'total', 'fecha'];
  dataSourceMaterial = new MatTableDataSource<any>;
  displayedColumnsEquipos: string[] = ['position', 'reference', 'descripcion', 'cantidad', 'desperdicio', 'precio', 'total', 'fecha'];
  dataSourceEquipo = new MatTableDataSource<Equipo>;
  displayedColumnsManoObras: string[] = ['position', 'reference', 'descripcion', 'cantidad', 'jornal', 'bono', 'totaljornal', 'totalbono', 'fecha'];
  dataSourceManosObra = new MatTableDataSource<ManoDeObra>;
  displayedColumnsTotalPartida: string[] = ['descripcion', 'total'];

  materialDetailList: any[] = [];
  equipmentDetailList: any[] = [];
  laborDetailList: any[] = [];

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  departureDetail: Partida;
  totalMateriales: number;
  totalEquipos: number;
  totalManoDeObra: number;
  totalBonoManoDeObra: number;
  prestManoDeObra: number;
  rendimiento: number;
  costoUnicoMateriales: number;
  costoUnicoEquipo: number;
  totalGeneralManoDeObra: number | null;
  costoUnicoManoDeObra: number;
  costoDirectoSubTotalA: number;
  gastosGeneralesAdmin: number;
  subTotalB: number;
  utilidadesImprevisto: number;
  subTotalC: number;
  financiamiento: number;
  precioUnitarioSinImpuesto: number;
  montoImpuestoIva: number;
  montoOtrosImpuestos: number;
  precioUnitario: number;
  apuConditionId: number = 0;
  statusPdf: boolean = true;
  oilCompany: boolean = false;

  totalGeneralManoDeObraTrans: string | undefined;
  costoUnicoManoDeObraRounded: string | undefined;
  costoUnicoEquipoRounded: string | undefined;
  costoDirectoSubTotalARounded: string | undefined;
  costoUnicoMaterialesRounded: string | undefined;
  subTotalBRounded: string | undefined;
  precioUnitarioRounded: string | undefined;
  horasRendimientoRounded: string | undefined;

  urlPdf: string;

  factorAjuste: number;
  rendAjustado: number;
  porcPrestacionesManoDeObra: number;
  porcGastosAdministrativos: number;
  porcUtilidadesImprevisto: number;
  porcFinanciamiento: number;
  porcImpuestoIva: number;
  porcOtrosImpuestos: number;
  porcIncidenciasMateriales: number;
  porcIncidenciasEquipos: number;
  porcIncidenciasManoDeObra: number;
  totalTrabajadores: any;
  workingHourDay: number;
  workingHour: number = 8;
  horasRendimiento: number;
  precioUnitarioHorasRend: number;

  description: string = '';
  reference: string = '';
  specificationMemo: string = '';
  statusMemo: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiCallService: ApiCallService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    public dialogDetallePartidaRef: MatDialogRef<DetallePartidaComponent>,
    public dialogSpecification: MatDialog,
    private helperClassService: HelperClassService
  ) { }

  ngOnInit() {
    registerLocaleData( es );

    this.departureDetailForm = new FormGroup ({
      description: new FormControl({ value: '', disabled: true }),
      shortDescription: new FormControl({ value: '', disabled: true}),
      reference: new FormControl({ value: '', disabled: true }),
      code: new FormControl({ value: '', disabled: true }),
      unity: new FormControl({ value: '', disabled: true }),
      yield: new FormControl({ value: '', disabled: true }),
      group: new FormControl({ value: '', disabled: true }),
      date: new FormControl({ value: '', disabled: true }),
      rating: new FormControl({ value: '', disabled: true }),
      commentary: new FormControl({value: '', disabled: true}),
      conditions: new FormControl({value: '', disabled: true}),
      clasification: new FormControl({value: '', disabled: true}),
      quantity: new FormControl({value: '', disabled: true}),
      dividirMaterial: new FormControl({value: false, disabled: true}),
      lossPermission: new FormControl({value: '', disabled: true}),
      difficulty: new FormControl({value: '', disabled: true}),
      unplanned: new FormControl({value: '', disabled: true}),
      mobilization: new FormControl({value: '', disabled: true}),
      other: new FormControl({value: '', disabled: true})
    });

    this.consultLineItemDetails();
  }

  async verDetallePDF(accion: string) {
    let reportpDFName = Constanst.PDF_REPORT_NAME.concat(this.data.row.reference);
    let reportpDFLogo = await this.helperClassService.toBase64Image(Constanst.PDF_REPORT_LOGO);
    let reportpDFWatermark = String(await this.helperClassService.toBase64Image(Constanst.PDF_REPORT_WATERMARK));

    var rowsMaterial = [];
    rowsMaterial.push([{ text: 'N°', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Und.', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Desp.', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Precio', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Material', style: 'subheader', bold: true, alignment: 'center' }]);
    for (let [i, material] of this.materialDetailList.entries()) {
      rowsMaterial.push([{ text: material.materialPosition, style: 'subheader', alignment: 'center' }, { text: material.materialDescription, style: 'subheader', alignment: 'left' }, { text: material.materialUnit, style: 'subheader', alignment: 'center' }, { text: this.decimalPipe.transform(material.materialQuantity, '1.4-4', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(material.wasteMaterial, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(material.priceMaterial, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(material.materialTotalPrice, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }]);
    }
    rowsMaterial.push([{ text: 'Total Materiales', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, true, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalMateriales, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsMaterial.push([{ text: 'Costo Unitario Materiales', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalMateriales, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);

    var rowsEquipment = [];
    rowsEquipment.push([{ text: 'N°', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', style: 'subheader', bold: true, alignment: 'center' }, { text: 'COP/Dep/Alq', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Precio', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Equipo', style: 'subheader', bold: true, alignment: 'center' }]);
    for (let [i, equipment] of this.equipmentDetailList.entries()) {
      rowsEquipment.push([{ text: equipment.equipmentPosition, style: 'subheader', alignment: 'center' }, { text: equipment.equipmentDescription, style: 'subheader', alignment: 'left' }, { text: this.decimalPipe.transform(equipment.quantityEquipment, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(equipment.depreciationEquipment, '1.6-6', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(equipment.priceEquipment, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(equipment.equipmentTotalPrice, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }]);
    }
    rowsEquipment.push([{ text: 'Total Equipos', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, true, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalEquipos, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsEquipment.push([{ text: 'Costo Unitario Equipos', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.costoUnicoEquipo, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);

    var rowsLabor = [];
    rowsLabor.push([{ text: 'N°', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', bold: true, style: 'subheader', alignment: 'center' }, { text: 'Jornal', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Bono', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Bono', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Jornal', style: 'subheader', bold: true, alignment: 'center' }]);
    for (let [i, labor] of this.laborDetailList.entries()) {
      rowsLabor.push([{ text: labor.laborPosition, style: 'subheader', alignment: 'center' }, { text: labor.laborDescription, style: 'subheader', alignment: 'left' }, { text: this.decimalPipe.transform(labor.quantityLabor, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.jornalLabor, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.laborTotalBonus, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.laborTotalBonus, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.laborTotalJornal, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }]);
    }
    rowsLabor.push([{ text: 'Subtotal Mano de Obra', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, true, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalBonoManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }, { text: this.decimalPipe.transform(this.totalManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsLabor.push([{ text: this.porcPrestacionesManoDeObra + '% Prestaciones Sociales', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, { text: '0.00', alignment: 'right', style: 'subheader' }, { text: this.decimalPipe.transform(this.prestManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsLabor.push([{ text: 'SubTotal + Prestaciones', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalBonoManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }, { text: this.decimalPipe.transform((this.prestManoDeObra + this.totalManoDeObra), '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsLabor.push([{ text: 'Total General Mano de Obra', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalGeneralManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsLabor.push([{ text: 'Costo Unico Mano de Obra', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.costoUnicoManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);

    let docDefinition = {
      pageMargin: [5, 50, 10, 20],
      pageSizes: Constanst.PDF_REPORT_PAGE_SIZE,
      background: {
        image: reportpDFWatermark,
        width: 600,
        absolutePosition: {
          x: 0, //Centra horizontalmente
          y: 100 //Centra verticalmente
        }
      },
      header: function (currentPage: any, pageCount: any) {
        return {
        margin: 8,
        table: {
          widths: ['*', '*'],
          body: [
            [{ image: reportpDFLogo, width: 160, height: 50, alignment: 'left', border: [false, false, false, false] }, { text: Constanst.PDF_REPORT_HADER_TEXT.concat('\n').concat(Constanst.PDF_REPORT_FOOTER_ONE + currentPage.toString() + Constanst.PDF_REPORT_FOOTER_TWO + pageCount), style: 'small', border: [false, false, false, false], alignment: 'right' }]
          ]
          }
        };
      },
      info: {
        title: reportpDFName,
        author: Constanst.PDF_REPORT_INFO_AUTHOR,
        subject: Constanst.PDF_REPORT_INFO_SUBJECT,
        keywords: Constanst.PDF_REPORT_INFO_KEYWORDS,
        creator: Constanst.PDF_REPORT_INFO_CREATOR,
        producer: Constanst.PDF_REPORT_INFO_PRODUCER
      },
      content: [
        {
          table: {
            widths: ['*'],
            body: [
              [{ text: 'ANALISIS DE PRECIO UNITARIO', fontSize: 12, bold: true, alignment: 'center', border: [false, false, false, false] }]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*'],
            body: [
              [{ text: 'Descripción: '.concat(this.data.row.description), fontSize: 9, bold: true, alignment: 'left', border: [false, false, false, false] }]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            widths: [44, '*', 30, '*', 30, '*', 52, '*', 30, '*'],
            body: [
              [{ text: 'Referencia: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.data.row.reference, style: 'subheader', border: [false, false, false, false] }, { text: 'Código: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.data.row.code, style: 'subheader', border: [false, false, false, false] }, { text: 'Unidad: ', bold: true, style: 'subheader', border: [false, false, false, false] }, { text: this.data.row.unit, style: 'subheader', border: [false, false, false, false] }, { text: 'Rendimiento: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.data.row.normalPerformance, '1.6-6', 'es'), style: 'subheader', border: [false, false, false, false] }, { text: 'Fecha: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.datePipe.transform(this.data.row.updateDate, Constanst.FORMAT_SHORT_DATE), style: 'subheader', border: [false, false, false, false] }],
            ]
          }
        },
        {
          text: '1. MATERIALES',
          style: 'header',
        },
        {
          style: 'tableExample',
          table: {
            widths: [10, 215, 30, 37, 35, 55, 60],
            body: rowsMaterial
          }
        },
        {
          text: '2. EQUIPOS',
          style: 'header',
        },
        {
          style: 'tableExample',
          table: {
            widths: [10, 215, 40, 65, 63, 60],
            body: rowsEquipment
          }
        },
        {
          text: '3. MANO DE OBRA',
          style: 'header',
        },
        {
          style: 'tableExample',
          table: {
            widths: [10, 215, 37, 37, 37, 50, 60],
            body: rowsLabor
          }
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*', 108],
            body: [
              [{ text: 'Costo Directo SubTotal A', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.costoDirectoSubTotalA, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcGastosAdministrativos + '% Administración y Gastos Generales', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.gastosGeneralesAdmin, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: 'SubTotal B', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.subTotalB, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcUtilidadesImprevisto + '% Utilidad e Imprevistos', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.utilidadesImprevisto, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: 'SubTotal C', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.subTotalC, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcFinanciamiento + '% Financiamientos', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.financiamiento, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: 'Precio Unitario sin Impuestos', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.precioUnitarioSinImpuesto, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcImpuestoIva + '% Impuestos (I.V.A)', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.montoImpuestoIva, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcOtrosImpuestos + '% Otros Impuestos (I.V.A)', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.montoOtrosImpuestos, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*', 108],
            body: [
              [{ text: 'PRECIO UNITARIO', style: 'header', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.precioUnitario, '1.2-2', 'es'), style: 'header', alignment: 'right' }]
            ]
          }
        }
      ],
      styles: {
        header: {
          fontSize: 9,
          bold: true,
        },
        subheader: {
          fontSize: 8,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 8
        },
        tableExample: {
          margin: 3,
          fontSize: 9,
        }
      }
    };

    if (accion == 'open') {
      pdfMake.createPdf(docDefinition).open();
    } else {
      pdfMake.createPdf(docDefinition).download(reportpDFName);
    }
  }

  consultLineItemDetails(){

    this.route = '/getLineItem';
    this.method = 'POST';
    let data = {
      idLineItem: this.data.row.idLineItem
    }
    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(
        responseItem => {

          this.departureDetailForm = new FormGroup ({
            description: new FormControl({ value: responseItem.data.description, disabled: true }),
            shortDescription: new FormControl({ value: responseItem.data.shortDescription, disabled: true}),
            reference: new FormControl({ value: responseItem.data.reference, disabled: true }),
            code: new FormControl({ value: responseItem.data.code, disabled: true }),
            unity: new FormControl({ value: responseItem.data.unit, disabled: true }),
            yield: new FormControl({ value: this.decimalPipe.transform(responseItem.data.normalPerformance, '1.6-6', 'es'), disabled: true }),
            group: new FormControl({ value: this.data.row.lineItemGrouping, disabled: true }),
            date: new FormControl({ value: this.datePipe.transform(responseItem.data.updateDate, 'dd/MM/yyyy'), disabled: true }),
            rating: new FormControl({ value: responseItem.data.rating, disabled: true }),
            commentary: new FormControl({value: '', disabled: true}),
            conditions: new FormControl({value: responseItem.data.apuCondition, disabled: true}),
            clasification: new FormControl({value: responseItem.data.lineItemConditionDescription, disabled: true}),
            quantity: new FormControl({value: this.decimalPipe.transform(responseItem.data.other, '1.2-2', 'es'), disabled: true}),
            dividirMaterial: new FormControl({value: responseItem.data.mrOption, disabled: true}),
            lossPermission: new FormControl({value: this.decimalPipe.transform(responseItem.data.lossPermission, '1.6', 'es'), disabled: true}),
            difficulty: new FormControl({value: this.decimalPipe.transform(responseItem.data.difficulty, '1.6', 'es'), disabled: true}),
            unplanned: new FormControl({value: this.decimalPipe.transform(responseItem.data.unplanned, '1.6', 'es'), disabled: true}),
            mobilization: new FormControl({value: this.decimalPipe.transform(responseItem.data.mobilization, '1.6', 'es'), disabled: true}),
            other: new FormControl({value: this.decimalPipe.transform(responseItem.data.other, '1.6', 'es'), disabled: true})
          });

          this.description = responseItem.data.description;
          this.reference = responseItem.data.reference;

          //Listas para mostrar en pagina detalle
          this.dataSourceEquipo = responseItem.data.equipmentDetailList;
          this.dataSourceManosObra = responseItem.data.laborDetailList;
          this.dataSourceMaterial = responseItem.data.materialDetailList;

          //Listas para mostrar en PDF
          this.equipmentDetailList = responseItem.data.equipmentDetailList;
          this.materialDetailList = responseItem.data.materialDetailList;
          this.laborDetailList = responseItem.data.laborDetailList;

          this.oilCompany = responseItem.data.oilCompany;

          this.factorAjuste = responseItem.data.lossPermission * responseItem.data.difficulty * responseItem.data.unplanned *
          responseItem.data.mobilization * responseItem.data.other;

          this.rendAjustado = this.factorAjuste * responseItem.data.normalPerformance;

          if (responseItem.data.urlPdf) {
            this.urlPdf = responseItem.data.urlPdf;
            this.statusPdf = false;
          }

          //Calculo de Totales
          this.totalMateriales = responseItem.data.materialDetailList.map((t: { materialTotalPrice: any; }) => t.materialTotalPrice).reduce((acc : number, value : number) => acc + value, 0);
          this.totalEquipos = responseItem.data.equipmentDetailList.map((t: { equipmentTotalPrice : any; }) => t.equipmentTotalPrice).reduce((acc : number, value : number) => acc + value, 0);
          this.totalManoDeObra = responseItem.data.laborDetailList.map((t: { laborTotalJornal : any; }) => t.laborTotalJornal).reduce((acc : number, value : number) => acc + value, 0);
          this.totalBonoManoDeObra = responseItem.data.laborDetailList.map((t: { laborTotalBonus : any; }) => t.laborTotalBonus).reduce((acc : number, value : number) => acc + value, 0);
          this.apuConditionId = responseItem.data.idApuCondition;

          //Consulta de las condiciones de la APU
          this.route = '/getApuConditionByIdApu';
          let data = {
            idApuCondition: this.apuConditionId
          }
          this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$)).subscribe(
            response => {
              this.rendimiento = responseItem.data.normalPerformance;
              //Seteando Porcentajes
              this.porcFinanciamiento = response.data.value.financing;
              this.porcGastosAdministrativos = response.data.value.administrativeExpense;
              this.porcImpuestoIva = response.data.value.iva;
              this.porcOtrosImpuestos = response.data.value.otherTax;
              this.porcUtilidadesImprevisto = response.data.value.unexpectedUtility;
              this.porcPrestacionesManoDeObra = response.data.value.benefit;

              //Calculo Materiales
              if (response.data.mrOption) {
                this.costoUnicoMateriales = Number(this.decimalPipe.transform(this.totalMateriales, '1.2-2')) / this.rendimiento;
              } else {
                this.costoUnicoMateriales = this.totalMateriales;
              }

              //Calculo Costo Unico Equipos
              this.costoUnicoEquipo = this.totalEquipos / this.rendimiento;

              //Calculos Mano de Obra
              this.prestManoDeObra = (this.porcPrestacionesManoDeObra / 100) * Number(this.decimalPipe.transform(this.totalManoDeObra, '1.2-2')?.replace(',', ''));
              this.totalGeneralManoDeObra = this.totalManoDeObra + this.totalBonoManoDeObra + this.prestManoDeObra;

              this.totalGeneralManoDeObraTrans = (this.decimalPipe.transform(this.totalGeneralManoDeObra, '1.2-2'))?.replace(',','');
              this.costoUnicoManoDeObra =  Number(this.totalGeneralManoDeObraTrans)/ this.rendimiento;

              this.costoUnicoManoDeObraRounded = (this.decimalPipe.transform(this.costoUnicoManoDeObra, '1.2-2'))?.replace(',','');
              this.costoUnicoEquipoRounded = (this.decimalPipe.transform(this.costoUnicoEquipo, '1.2-2'))?.replace(',','');
              this.costoUnicoMaterialesRounded = (this.decimalPipe.transform(this.costoUnicoMateriales, '1.2-2'))?.replace(',','');


              //Calculos Partida
              this.costoDirectoSubTotalA = (Number(this.costoUnicoMaterialesRounded) + Number(this.costoUnicoEquipoRounded) + Number(this.costoUnicoManoDeObraRounded));

              this.costoDirectoSubTotalARounded = (this.decimalPipe.transform(this.costoDirectoSubTotalA, '1.2-2'))?.replace(',','');

              this.gastosGeneralesAdmin = Number(this.costoDirectoSubTotalARounded) * (this.porcGastosAdministrativos/100);
              let gastosGeneralesAdminRounded = (this.decimalPipe.transform(this.gastosGeneralesAdmin, '1.2-2'))?.replace(',', '');

              this.subTotalB = (Number(this.costoDirectoSubTotalARounded)) + (Number(gastosGeneralesAdminRounded));
              this.subTotalBRounded = (this.decimalPipe.transform(this.subTotalB, '1.2-2'))?.replace(',','');

              this.utilidadesImprevisto = (Number(this.subTotalBRounded) * this.porcUtilidadesImprevisto)/100;

              this.subTotalC = (Number(this.subTotalBRounded)) + this.utilidadesImprevisto;

              this.financiamiento = (this.subTotalC * this.porcFinanciamiento)/100;

              this.precioUnitarioSinImpuesto = this.subTotalC + this.financiamiento;
              this.montoImpuestoIva = this.precioUnitarioSinImpuesto * (this.porcImpuestoIva/100);
              this.montoOtrosImpuestos = this.precioUnitarioSinImpuesto * (this.porcOtrosImpuestos/100);

              this.precioUnitario = this.precioUnitarioSinImpuesto + this.montoImpuestoIva + this.montoOtrosImpuestos;
              this.precioUnitarioRounded = (this.decimalPipe.transform(this.precioUnitario, '1.2-2'))?.replace(',','');

              //Calculo % de incidencias
              this.porcIncidenciasMateriales = ((Number(this.costoUnicoMaterialesRounded)) / (Number(this.costoDirectoSubTotalARounded))) * 100;
              this.porcIncidenciasManoDeObra = ((Number(this.costoUnicoManoDeObraRounded)) / (Number(this.costoDirectoSubTotalARounded))) * 100;
              this.porcIncidenciasEquipos = ((Number(this.costoUnicoEquipoRounded)) / (Number(this.costoDirectoSubTotalARounded))) * 100;


              this.totalTrabajadores = responseItem.data.laborDetailList.map((t: { quantityLabor : any; }) => t.quantityLabor).reduce((acc : number, value : number) => acc + value, 0);
              this.workingHourDay = this.totalTrabajadores * this.workingHour;
              this.horasRendimiento = this.workingHourDay / this.rendimiento;
              this.horasRendimientoRounded = (this.decimalPipe.transform(this.horasRendimiento, '1.3-3'))?.replace(',','');
              this.precioUnitarioHorasRend = (Number(this.precioUnitarioRounded)) / (Number(this.horasRendimientoRounded));

              this.route = '/getDescriptiveMemoryByIdLineItem';
              this.method = 'POST';
              let data = {
                idLineItem: this.data.row.idLineItem
              }
              this.apiCallService.call$(data, this.route, this.method, true, '', true)
                .pipe(takeUntil(this.destroy$)).subscribe(
                  responseMemo => {
                    //console.log(responseMemo);
                    if (responseMemo.status === Constanst.RESPONSE_STATUS_SUCCESS && responseMemo.data.length > 0 && !responseMemo.data[0].memory.isEmpty) {
                      this.specificationMemo = responseMemo.data[0].memory;
                      this.statusMemo = false;
                    }
                  });

              this.apiCallService.hideSpinner();
            }
          );
        }
      );
  }

  verEspecificaciones(fileUrl: string) {
    this.helperClassService.validateDocumentExists(fileUrl).subscribe(existe => {
      if (existe) {
        window.open(fileUrl, '_blank');
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_DOCUMENT_NOT_AVAILABLE, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    });
  }

  closeDialogDetallePartida() {
    this.dialogDetallePartidaRef.close();
  }

  openMemoSpecification(specification: string) {
    this.dialogSpecification.open(DialogInformationComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      data: { specification, reference: this.reference, description: this.description }
    });
  }
}
